<template>
  <div id="container">
    <div class="box-content-title">
      <div class="title-font-style">
        <span>团队欠款合同</span>
      </div>
    </div>
    <el-form class="search-style">
      <el-row :gutter="20">
        <el-col :span="4">
          <el-form-item>
            <el-select v-model="queryParams.column" @change="onChangeColumn">
              <el-option
                v-for="(item,index) in teamDebtContractRecord"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <el-input v-model="queryParams.value" placeholder="请输入关键词"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item>
            <el-button type="primary" @click="onSearch">搜索</el-button>
            <el-button @click="onReset">重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="box-table" :style="{height: $store.state.Sell.heightTitle+'px'}">
      <el-table
        border
        ref="tableRef"
        :data="list"
        :max-height="$store.state.Sell.heightTitle"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        v-loading="loadingTable"
        element-loading-text="拼命加载中请稍后..."
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column label="合同编号" width="150px" fixed>
          <template slot-scope="scope">
            <span class="approval" @click="toHeTong(scope.row)">{{ scope.row.contractCode }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed label="客户名称" show-overflow-tooltip min-width="120px">
          <template slot-scope="scope">
            <div
              class="approval line-limit-length"
              @click="toCusName(scope.row)"
            >{{scope.row.cusName}}</div>
          </template>
        </el-table-column>
        <el-table-column label="合同金额">
          <template slot-scope="scope">{{scope.row.contractTotal|priceFilter}}</template>
        </el-table-column>
        <el-table-column label="应收账款">
          <template slot-scope="scope">{{scope.row.accountsCollect|priceFilter}}</template>
        </el-table-column>
        <el-table-column label="已到期应收账款" width="120">
          <template slot-scope="scope">{{scope.row.accountsDue|priceFilter}}</template>
        </el-table-column>
        <el-table-column label="未到期应收账款" width="120">
          <template slot-scope="scope">{{scope.row.accountsOutstanding|priceFilter}}</template>
        </el-table-column>
        <el-table-column label="已收账款">
          <template slot-scope="scope">{{scope.row.accountsReceived|priceFilter}}</template>
        </el-table-column>
        <el-table-column label="欠款起始日" width="110">
          <template slot-scope="scope">{{scope.row.initialDueDate|dateFilterD}}</template>
        </el-table-column>
        <el-table-column prop="staffCnName" label="当前负责人"></el-table-column>
        <el-table-column prop="orgName" label="所属部门"></el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <pagination
        :total="total"
        :currentPage="currentPage"
        :pageSize="pageSize"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
    </div>
  </div>
</template>
<script>
import pagination from '@/components/pagination'
import { queryAllByTeam } from '@/api/sell/sellManage'
import { teamDebtContractRecord } from './util/data'
export default {
  components: { pagination },
  data() {
    return {
      columnArr: [],
      queryParams: { column: 'cusName' },
      teamDebtContractRecord,
      loadingTable: false, // 列表loading
      list: [], // 列表数据
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      total: 0 // 列表总数
    }
  },
  watch: {
    queryParams(val) {
      if (!val.column) {
        this.$set(this.queryParams, 'column', 'cusName')
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    // 合同详情
    toHeTong(row) {
      this.$router.push({
        name: 'contractEdit',
        query: { id: row.id, cusId: row.cusId }
      })
    },
    toCusName(row) {
      this.$router.push({ name: 'customer/details', query: { id: row.cusId } })
    },
    onChangeColumn(val) {
      this.queryParams = {}
      this.queryParams.column = val
    },
    onSearch() {
      if (this.queryParams.column && this.queryParams.value) {
        this.pageSize = 30
        this.currentPage = 1
        this.columnArr = [this.queryParams]
        this.getList()
      } else {
        this.$message.error('搜索条件不能为空')
      }
    },
    onReset() {
      this.columnArr = []
      this.queryParams = {}
      this.currentPage = 1
      this.pageSize = 30
      this.getList()
    },
    getList() {
      this.loadingTable = true
      const obj = {
        criteriaVoList: [...this.columnArr],
        queryPageName: ''
      }
      queryAllByTeam(this.currentPage, this.pageSize, obj).then((res) => {
        if (res.data.code === 200) {
          this.loadingTable = false
          this.list = res.data.obj.records
          this.total = res.data.obj.total
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 页数
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    }
  }
}
</script>
